import './CcrcBottom.css';

// 하드 코딩 형식. 변경 필요
// store의 ccrcModal에서 전역 상태 관리 필요. (ccrcModal nameing도 수정 필요)
export const CcrcBottom = ({
  isAgreed,
  setIsAgreed,
  handleSubmit,
  handleDetailClick,
  activeSubmit,
  ccrcText,
  btnText,
}) => {
  return (
    <div className='btm-area gradient-btm agree-btm'>
      <div className='agree-chk-form agree-btm-content'>
        <div className='agree-chk-form'>
          <div className='agree-chk-list'>
            <div className='agree-item choice_type2'>
              <input
                type='checkbox'
                aria-label='개인정보 수집·이용 동의'
                className='inp_choice'
                checked={isAgreed}
                onChange={() => {
                  setIsAgreed(!isAgreed);
                }}
              />
              <label aria-hidden='false'>
                <span className='icon icon_check'></span>
                {ccrcText}
              </label>

              <button className='detail-btn' type='button' onClick={handleDetailClick}>
                <span className='icon icon_more'>상세 보기</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <button
        type='button'
        className='btn btm-btn-primary'
        onClick={handleSubmit}
        disabled={!isAgreed || !activeSubmit}
      >
        <span className='btn-txt-01'>{btnText}</span>
      </button>
    </div>
  );
};
